<div class="wrapper">
  <a routerLinkActive="active" mat-button routerLink="/conversion-infos" i18n>
    <mat-icon>apps</mat-icon>
    Conversions
  </a>
  <a routerLinkActive="active" mat-button routerLink="/conversion-errors" i18n>
    <mat-icon>error</mat-icon>
    Errors
  </a>
  <a routerLinkActive="active" mat-button routerLink="/customers" i18n>
    <mat-icon>group</mat-icon>
    Customers
  </a>
  <a routerLinkActive="active" mat-button routerLink="/stats" i18n>
    <mat-icon>timeline</mat-icon>
    Stats
  </a>
  <a routerLinkActive="active" mat-button routerLink="/archive" i18n>
    <mat-icon>archive</mat-icon>
    Archive
  </a>
  <a routerLinkActive="active" mat-button routerLink="/maintenance" i18n>
    <mat-icon>engineering</mat-icon>
    Maintenance
  </a>
  <a routerLinkActive="active" mat-button routerLink="/jobs" i18n>
    <mat-icon>dashboard</mat-icon>
    Jobs
  </a>
  <a routerLinkActive="active" mat-button (click)="logout()" i18n>
    <mat-icon>power_settings_new</mat-icon>
    Logout
  </a>
</div>
